module.exports = __webpack_public_path__ + "img/report-c.11b26e7 1.13cf828.svg";